import { FilterBody, FilterQuery } from '@yes.technology/react-toolkit'
import { merge } from 'lodash'
import deepOmit from 'shared/utils/object/deepOmit'
import { useFetchYesObjects } from 'yesObject/shared'
import { baseProps } from '../contants'
import getClonedFilterquery from '../utils/getClonedFilterquery'
import getFilteredStartDate from '../utils/getFilteredStartDate'
import getStartDate from '../utils/getStartDate'

type UseStartMonthWithAvailableEventsProps = {
  filterquery: FilterQuery
  filterFieldsFilterQuery?: FilterQuery
  objectclassUuid: string
}

const useStartDateWithAvailableEvents = ({
  filterquery,
  filterFieldsFilterQuery,
  objectclassUuid
}: UseStartMonthWithAvailableEventsProps) => {
  const { filteredStartDate } = getFilteredStartDate(filterFieldsFilterQuery)

  const date = filteredStartDate ? getStartDate(filteredStartDate) : new Date()

  const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)

  const startDate = startOfMonth.toISOString()

  const filterBody: FilterBody = {
    ...baseProps,
    objectclass: objectclassUuid,
    project_fields: {
      start_date: 1
    },
    query: {
      ...merge(
        getClonedFilterquery(filterquery),
        deepOmit(filterFieldsFilterQuery ?? {}, 'start_date.des'),
        filteredStartDate
          ? getClonedFilterquery(filterFieldsFilterQuery ?? {})
          : {
              $and: [
                {
                  $or: [
                    { 'start_date.des': { $gte: startDate } },
                    { 'start_date.des': { $lte: startDate } }
                  ]
                }
              ]
            }
      )
    }
  }

  const { isLoading, yesObjects: data } = useFetchYesObjects({
    filterBody,
    initialPagination: {
      limit: 1,
      offset: 0
    },
    initialSortOptions: [{ start_date: 'desc' }],
    enabled: !!objectclassUuid
  })

  const result = data?.[0]?.start_date as string

  const objectStartDate = result || startDate

  return { startDate: objectStartDate, isLoading }
}

export default useStartDateWithAvailableEvents
